// Default agents that are created for every new user
import { Agent } from '../state';
import { AVAILABLE_TOOLS } from '../tools';

export const DEFAULT_AGENTS: Omit<Agent, 'id'>[] = [
  {
    name: "Customer Support Agent",
    description: "Professional customer service assistant that helps with inquiries, complaints, and general support",
    status: 'active',
    language: 'English',
    industry: 'Customer Support',
    voice: "zephyr",
    allowInterruptions: true,
    noiseReduction: true,
    systemPrompt: "You are a friendly and professional customer support agent. You help customers with their inquiries, resolve complaints, and provide excellent service. Always be polite, patient, and solution-oriented. If you don't know something, offer to connect them with a human agent.",
    formality: 70,
    enthusiasm: 50,
    temperature: 0.7,
    model: 'gemini-2.5-flash',
    topP: 0.9,
    knowledgeBase: [
      {
        type: 'url',
        url: "https://example.com/products"
      },
      {
        type: 'url',
        url: "https://example.com/faq"
      }
    ],
    tools: AVAILABLE_TOOLS.map(t => ({ ...t, isEnabled: true }))
  },
  {
    name: "Sales Assistant",
    description: "Expert sales representative that helps with product recommendations, pricing, and closing deals",
    status: 'active',
    language: 'English',
    industry: 'Sales',
    voice: "puck",
    allowInterruptions: true,
    noiseReduction: true,
    systemPrompt: "You are an experienced sales professional with deep knowledge of our products and services. Your goal is to understand customer needs, recommend appropriate solutions, and guide them through the sales process. Be consultative, not pushy. Ask qualifying questions and provide value.",
    formality: 60,
    enthusiasm: 70,
    temperature: 0.8,
    model: 'gemini-2.5-flash',
    topP: 0.9,
    knowledgeBase: [
      {
        type: 'url',
        url: "https://example.com/catalog"
      },
      {
        type: 'url',
        url: "https://example.com/pricing"
      }
    ],
    tools: AVAILABLE_TOOLS.map(t => ({ ...t, isEnabled: true }))
  },
  {
    name: "Personal Assistant",
    description: "Your personal AI helper for daily tasks, scheduling, and information retrieval",
    status: 'active',
    language: 'English',
    industry: 'General',
    voice: "kore",
    allowInterruptions: true,
    noiseReduction: false,
    systemPrompt: "You are a helpful personal assistant. Provide concise and accurate information, assist with scheduling and reminders, and help with daily tasks. Be friendly, efficient, and proactive in offering assistance.",
    formality: 50,
    enthusiasm: 50,
    temperature: 0.7,
    model: 'gemini-2.5-flash',
    topP: 0.9,
    knowledgeBase: [],
    tools: AVAILABLE_TOOLS.map(t => ({ ...t, isEnabled: true }))
  }
];

export const createDefaultAgents = async (userId: string) => {
  const { collection, addDoc } = await import('firebase/firestore');
  const { db } = await import('../firebase');
  
  const agentsCollectionRef = collection(db, 'users', userId, 'agents');
  
  for (const agentConfig of DEFAULT_AGENTS) {
    await addDoc(agentsCollectionRef, {
      ...agentConfig,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }
  console.log(`Created ${DEFAULT_AGENTS.length} default agents for user ${userId}`);
};